; (function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .directive('customizeFormat', customizeFormat)

  function customizeFormat () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        form: '=',
        onChangeSize: '&',
        product: '<'
      },
      templateUrl: '/arts/directives/customize-format/customize-format-directive.html?$$REVISION$$',
      controller: 'CustomizeFormatController'
    }
  }
})()
